import { render, staticRenderFns } from "./dict.vue?vue&type=template&id=290e8808&scoped=true&"
import script from "./dict.vue?vue&type=script&lang=js&"
export * from "./dict.vue?vue&type=script&lang=js&"
import style0 from "./dict.vue?vue&type=style&index=0&id=290e8808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290e8808",
  null
  
)

export default component.exports